import React, { useEffect, useState } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from "saur_ui_library/src/Atoms/Word/Word";
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import { getInfoBulleMessage, resetImputLabel, resetOptions } from '../../../utils/helpers/module/filtersHelper';
import DataSelector from '../../common/component/dataSelector';
import Legend from '../../common/component/Legend';
import SingleFilter from '../component/SingleFilter';
import { avoidDuplicate, getStepCodesFromLayer108 } from '../../../utils/helpers/module/ecpHelper';
import { loaderDataComponent } from '../../../utils/helper';
import { getEcpMode } from '../../../utils/helpers/view/ecpDetailHelper';

const FiltersEcp = (props: any) => {
  const [currentMode, setCurrentMode] = useState<'pr' | 'step'>('pr');
  // Use currentMode state for consistent re-renders when mode changes
  const isStepMode = currentMode === 'step';
  console.log('[DEBUG] FiltersEcp render - currentMode:', currentMode, 'isStepMode:', isStepMode);
  // const for dropdownlist on change
  const [fonctionnement, setFonctionnement] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('ecp_color')!) || ''
  );
  const [commune, setCommune] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('ecp_commune')!) || {
      name: '',
      code: '',
      outField: 'InseeCode',
    }
  );
  const [bassinCollecte, setBassinCollecte] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('ecp_bassinCollecte')!) || {
      name: '',
      code: '',
      outField: 'Code',
    }
  );
  // const for dropdownlists options
  const [communeOptions, setCommuneOptions] = useState<any>([]);
  const [bassinCollecteOptions, setBassinCollecteOptions] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const infoBulleMessageDataSelectorEcp = getInfoBulleMessage(props.module);

  // get communes options
  const getCommune = async () => {
    let communesData: any[] = props.allInseeCodesContract;
    if (communesData.length === 0) {
      resetImputLabel('ecp-filtre-commune');
    }
    let singleCommunesData = avoidDuplicate(communesData, 'name');
    setCommuneOptions(singleCommunesData);
  };

  // get installs options (fetch STEP in STEP mode, filter collection pools in PR mode)
  const getBassinCollecte = async (pCommune: any) => {
    let res: any[] = [];
    
    // Read mode directly from sessionStorage to ensure we have the current mode
    const stepMode = getEcpMode() === 'step';
    
    if (stepMode) {
      // In STEP mode, fetch STEP installations from Layer 108
      const sessionContractCode = window.sessionStorage.getItem('contractCode');
      res = await getStepCodesFromLayer108(sessionContractCode || '', pCommune);
      console.log('[DEBUG] FiltersEcp - STEP mode: fetched installations:', res);
    } else {
      // In PR mode, filter from collection pools
      res = pCommune !== '' ? props.allBc.filter((c: any) => c.commune === pCommune) : props.allBc;
    }
    
    if (res.length === 0) {
      resetImputLabel('ecp-filtre-bassinCollecte');
    }
    
    let newBassinData: any[] = [];
    res.forEach((c: any) => {
      newBassinData.push({
        id: c.id,
        name: c.name,
        code: c.avalPoint !== null ? c.avalPoint : c.name,
        avalPoint: c.avalPoint,
        commune: c.commune,
        outField: 'Code',
      });
    });
    setBassinCollecteOptions(newBassinData);
    return newBassinData;
  };

  useEffect(() => {
    setLoading(true);
    getCommune().then(() => {
      setLoading(false);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // watch sessionStorage ecp_mode changes
  useEffect(() => {
    const handleModeChange = () => {
      const newMode = getEcpMode();
      setCurrentMode((prevMode) => {
        if (prevMode !== newMode) {
          console.log('[DEBUG] FiltersEcp mode detected:', newMode);
          if (newMode === 'step') {
            setFonctionnement('');
            window.sessionStorage.setItem('ecp_color', JSON.stringify(''));
          }
        }
        return newMode;
      });
    };
    // Initial check
    handleModeChange();
    // Poll sessionStorage every 100ms to detect mode changes
    const interval = setInterval(handleModeChange, 100);
    return () => clearInterval(interval);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // trigger dynamic dropdownlists hence on change (commune, type and deversement)
  useEffect(() => {
    if(loading === false){
      setLoading(true);
      getBassinCollecte(commune.name).then(() => {
        setLoading(false);
      });
    }
  }, [commune, fonctionnement, isStepMode]); // eslint-disable-line react-hooks/exhaustive-deps

  // we need to use this useEffect to update table 
  // when you open the module because this component is allready mounted
  // we need to wait for the end of the requests in ViewComponent
  useEffect(() => {
    // Re-populate commune dropdown when data arrives (handles race condition
    // where layers load before getCommunesForEcp resolves)
    setLoading(true);
    getCommune().then(() => {
      setLoading(false);
    });
    getBassinCollecte(commune.name).then((bassinData: any) => {
      props.parentCallback({
        Color: isStepMode ? '' : fonctionnement,
        InseeCode: commune,
        Code: commune.name === '' ? bassinCollecte : {
          name: '',
          code: '',
          outField: 'Code',
        },
        CollectionPools: bassinData,
      });
    });
  }, [props.allInseeCodesContract, currentMode]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container className='filterForm'>
      <Card automatedTestId={props.module + '-filter'}>
        <Word
          value='FILTRER MA RECHERCHE'
          textStyle='title'
          variant='h1'
          automatedTestId='search-word'
        />
        {!isStepMode && (
          <Legend type={localStorage.getItem('type')!} />
        )}
        {!isStepMode && (
          <Container className='fonctionnement'>
            <Word
              value='Fonctionnement'
              textStyle='normalReg'
              variant='p'
              automatedTestId='id-fonctionnement'
            />
            <DataSelector
              infoBulles={infoBulleMessageDataSelectorEcp}
              sendSelectedColor={(d: any) => {
                setFonctionnement(d);
                window.sessionStorage.setItem('ecp_color', JSON.stringify(d));
                if (fonctionnement !== '') {
                  getBassinCollecte(commune.name).then((bassinData: any) => {
                    props.parentCallback({
                      Color: d,
                      InseeCode: commune,
                      Code: bassinCollecte,
                      CollectionPools: bassinData,
                    });
                  });
                }
              }}
              type='ecp'
              sessionStorageName='ecp_color'
            />
          </Container>
        )}
        {commune !== null && (
          <SingleFilter
            module='ecp'
            title='Communes :'
            filterName='commune'
            filterOptions={communeOptions}
            parentCallback={(d) => {
              setCommune(d);
              resetOptions(
                d,
                'ecp-filtre-bassinCollecte',
                setBassinCollecteOptions
              );
              if (isStepMode) {
                // In STEP mode, fetch STEP installations for the selected commune (or all if commune is cleared)
                getBassinCollecte(d?.name || '').then((bassinData: any) => {
                  props.parentCallback({
                    Color: '',
                    InseeCode: d,
                    Code: {
                      name: '',
                      code: '',
                      outField: 'Code',
                    },
                    CollectionPools: bassinData,
                  });
                });
              } else {
                getBassinCollecte(d.name).then((bassinData: any) => {
                  props.parentCallback({
                    Color: fonctionnement,
                    InseeCode: d,
                    Code: {
                      name: '',
                      code: '',
                      outField: 'Code',
                    },
                    CollectionPools: bassinData,
                  });
                });
              }
              window.sessionStorage.setItem('bassinecp', JSON.stringify({name: '', code: ''}));
            }}
            outField='InseeCode'
          />
        )}
        {bassinCollecte !== null && (
          <SingleFilter
            module='ecp'
            title={isStepMode ? 'Installation :' : 'Bassin de collecte :'}
            filterName={isStepMode ? 'installation' : 'bassinCollecte'}
            filterOptions={bassinCollecteOptions}
            parentCallback={(d) => {
              if (isStepMode) {
                props.parentCallback({
                  Color: '',
                  InseeCode: commune,
                  Code: d,
                  // In STEP mode, pass bassinCollecteOptions as CollectionPools so getEcpTableData can match records
                  CollectionPools: bassinCollecteOptions,
                });
                return;
              }
              getBassinCollecte(commune.name).then((bassinData: any) => {
                props.parentCallback({
                  Color: fonctionnement,
                  InseeCode: commune,
                  Code: d,
                  CollectionPools: bassinData,
                });
              });
              // manage highlights
              if (d === null) {
                window.sessionStorage.setItem('bassinecp', JSON.stringify({name: '', code: ''}));
                window.sessionStorage.setItem('codesEcp', 'null');
              } else {
                window.sessionStorage.setItem('bassinecp', JSON.stringify(d));
              }
            }}
            outField='Code'
          />
        )}
        {loaderDataComponent(loading)}
      </Card>
    </Container>
  );
};;
export default FiltersEcp;
